import { Notify } from 'quasar';

Notify.setDefaults({
	position: 'top-right',
	timeout: 2500,
	textColor: 'white',
	color: 'info',
});

Notify.error = (message, options = {}) => Notify.create({
	message,
	color: 'negative',
	icon: 'error_outline',
	timeout: 0,
	actions: [{ icon: 'close', color: 'white' }],
	...options,
});

Notify.warn = (message, options = {}) => Notify.create({
	message,
	color: 'warning',
	icon: 'warning',
	...options,
});

Notify.success = (message, options = {}) => Notify.create({
	message,
	color: 'positive',
	icon: 'done',
	...options,
});

Notify.info = (message, options = {}) => Notify.create({
	message,
	color: 'info',
	icon: 'info',
	...options,
});

Notify.removeAll = () => {
	Object.values(Notify.__vm.notifs)
		.flat()
		.forEach(notif => Notify.__vm.remove(notif));
};

Notify.__vm.$q.notify.error = Notify.error;
Notify.__vm.$q.notify.warn = Notify.warn;
Notify.__vm.$q.notify.success = Notify.success;
Notify.__vm.$q.notify.info = Notify.info;
Notify.__vm.$q.notify.removeAll = Notify.removeAll;
